<template>
  <div class="again">
    <div class="left" :class="{ 'styleContinue': !checkContinue }" v-if="refundTicketState && applyRefundTicket" @click="refundTicket">申请退票</div>
    <router-link  to="/makeinvoice" class="center" v-if="isFlag || overTimeFlag">开具发票</router-link>
    <div class="right" v-if="checkContinue" @click="againBuyingTickets">
      <div class="surplus">继续购票</div>
    </div>
    <selectpopup v-if="popupstate" @onselectpopup="onselectpopup" title="退票申请" content="是否确定要进行退票？"/>
  </div>
</template>

<script>
import {
  getIndividualMultiRefundTicket,
  getGroupMultiRefundTicket,
  getFreeMultiRefundTicket
  } from '@/service/order/common.js'
export default {
  name: "again",
  // props: ['orderDetails', 'tickettype', 'ticketlist', 'refundTicketPath'],
  props: {
    orderDetails: {
      type: Object,
      required: true
    },
    tickettype: {
      type: String,
      required: true
    },
    ticketlist: {
      type: String,
      required: true
    },
    refundTicketPath: {
      type: String,
      required: true
    },
    checkContinue: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      popupstate: false,
      applyRefundTicket: true,
      refundRecord: false,
      isFlag:false,
      overTimeFlag: false,
    }
  },
  methods: {
    refundTicket(){
      if(this.refundRecord)return this.$toast('正在退票');
      if(this.orderDetails.itemList.length > 1){
        const { orderId } = this.$route.query;
        window.sessionStorage.setItem('orderDetails', JSON.stringify(this.orderDetails));
        return this.$router.push(`/${this.refundTicketPath}?orderId=${orderId}`)
      };
      this.popupstate = true;
    },
    againBuyingTickets(){
      this.$router.push(this.ticketlist);
    },
    async onselectpopup(state){
      if(state === 'determine'){
        const { orderId } = this.$route.query;
        const { itemList } = this.orderDetails;
        const option = {
          userId: JSON.parse(window.localStorage.getItem('userInfo')).userId,
          orderId,
          orderItemIdList: [itemList[0].itemId],
        };
        let data;
        // 散客票退票
        if(this.tickettype === 'touristorderdetails' || this.tickettype === 'hmtorderdetails'){
          data = await getIndividualMultiRefundTicket.call(this, option);
        }else if(this.tickettype === 'guideorderdetails'){
        // 导游票退票
          data = await getGroupMultiRefundTicket.call(this, option);
        }else if(this.tickettype === 'freeorderdetails'){
        // 免费票退票
          data = await getFreeMultiRefundTicket.call(this, option);
        }
        if(data.status === "0"){
          this.refundRecord = true;
          this.$loading.loadingStata = true;
          setTimeout(() => {
            if(this.$loading.loadingStata){
              this.$loading.loadingStata = false;
              this.$toast({
                message: '请稍等，退票申请中',
                duration: 3000
              });
              this.refundRecord = false;
            };
          }, 5000);
        };
        this.$emit('clickAgain');
      }
      this.popupstate = false;
    }
  },
  computed:{
    refundTicketState(){
      return this.orderDetails.itemList.every((item) => item.canRefund === '0');
    }
  },
  watch:{
    orderDetails: {
      handler(newvalue){
        this.applyRefundTicket = newvalue.itemList.some(item => item.ticketStatus === "0" || item.ticketStatus === "1" || item.ticketStatus === "2");
        this.overTimeFlag = newvalue.itemList.some(item => item.canInvoice == "1" && item.invoiceStatus == "0" && item.ticketStatusName == '已逾期');
        this.isFlag = newvalue.itemList.some(item => (item.ticketStatus == "3" || item.ticketStatus == "4") && item.canInvoice == "1" && item.invoiceStatus == "0" && item.ticketStatusName !== '已逾期');
      },
      deep: true,
      immediate: true,
    },
    popupstate(newValue){
      this.$beyondHiding(newValue)
    },
    popupstate(newValue){
      this.$beyondHiding(newValue)
    }
  },
};
</script>

<style scoped lang='less'>
.again{
  height: 1.6rem;
  position: fixed;
  width: 100%;
  display: flex;
  bottom: 0;
  left: 0;
  .left{
    color: #333333;
    font-size: .426667rem;
    background: #FFFFFF;
    line-height: 1.6rem;
    padding: 0 1.066667rem;
  }
  .center{
    background: #FDF1E1;
    flex: 1;
    font-size: .426667rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #C4D1E3;
  }
  .styleContinue{
    background: #3B6D9C;
    width: 100%;
    text-align: center;
    color: rgba(255, 255, 255, 1);
  }
  .right{
    background: #3B6D9C;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .surplus{
      color: rgba(255, 255, 255, 1);
      font-size: .24rem  * 2;
    }
    .continue{
      color: #FFFFFF;
      font-size: .24rem * 2;
    }
  }
}
</style>
